module.exports = __webpack_public_path__ + "0eb562ea6583b62512531ca1c8cba62f.svg";